<template>
  <main class="main programmazione-siae max-width">
    <article>
  		<h1 class="title-medium centered regular">Effettua il login</h1>
      <login-form></login-form>
    </article>

    <snackbar 
      :states="states" 
      :state="state"
      :showSnackbar="showSnackbar"
      @close="showSnackbar = false"
    ></snackbar>
  </main>
</template>

<script>
import axios from 'axios/dist/axios';
import LoginForm from './LoginForm.vue';
import Snackbar from './Snackbar.vue';

export default {
  name: 'Login',

  data() {
    return {
      states: [
        {name: 'password-updated', message: 'La password è stata aggiornata con successo. Adesso puoi effettuare il login', bgColor: 'aqua'}
      ],
      state: undefined,
      showSnackbar: false
    }
  },

  mounted() {
    const q = this.$route.query;
    if(q.state && q.state == 'passwordRestore:success') {
      this.state = 'password-updated';
      this.showSnackbar = true;
    }

    document.title = 'Caramba - Login';
  },

  components: {
    'login-form': LoginForm,
    'snackbar': Snackbar
  }
}
</script>




// WEBPACK FOOTER //
// src/vue/components/Login.vue